import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from 'vuex-persistedstate'

import * as getters from './getter'
import mutations from './mutations'
import actions from './actions'

import auth from './modules/auth'
import config from './modules/config'
import category from './modules/category'
import address from './modules/address'
import region from './modules/region'
import detail from './modules/detail'
import product from './modules/product'
import cart from './modules/cart'
import search from './modules/search'
import order from './modules/order'
import tabBar from './modules/tabbar'
import message from './modules/message'
import checkout from './modules/checkout'
import home from './modules/home'
import discount from './modules/discount'
import resint from './modules/resint'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth,
		config,
		category,
		address,
		region,
		detail,
		product,
		cart,
		search,
		order,
		tabBar,
		checkout,
		message,
		home,
		discount,
		resint
	},
	getters: getters,
	actions,
	mutations,
	plugins: [
		createPersistedState({
			key: 'ecm',
			paths: [
				'auth',
				'region',
				'tabBar',
				'category',
				'cart',
				'message',
				'home'
			]
		})
	]
})



// WEBPACK FOOTER //
// ./src/store/index.js